<template>
  <div>
    <!-- 广告名称 -->
    <div v-if="formKey === 'campaign_name' && !formItem.isPreview">
      <el-link v-for="word in formItem.word_list" :key="word" class="mr-10" :underline="false" type="primary" @click="insertWord(`{${word}}`, formItem)">+{{ word }}</el-link>
    </div>
  </div>
</template>

<script>
import { component_props } from '@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/model/props';
export default {
  props: {
    ...component_props,
  },
  methods: {
    /**
     * 插入通配符
     * @param word 通配符
     * @param form_item 表单项
     */
    insertWord(word, form_item) {
      const name = form_item.value;
      const match_list = name.match(/{[^}{]*?}/g) || [];
      form_item.value = match_list.includes(word) ? name.replace(word, '') : name.concat(word);
    },
  },
};
</script>
